const fontList = {
    Arial: {
        normal: "ArialRegular.ttf",
        italics: "ArialItalic.ttf",
        bold: "ArialBold.ttf",
        bolditalics: "ArialBoldItalic.ttf",
    },
    CourierNew: {
        normal: "CourierNewRegular.ttf",
        italics: "CourierNewItalic.ttf",
        bold: "CourierNewBold.ttf",
        bolditalics: "CourierNewBoldItalic.ttf",
    },
    Georgia: {
        normal: "GeorgiaRegular.ttf",
        italics: "GeorgiaItalic.ttf",
        bold: "GeorgiaBold.ttf",
        bolditalics: "GeorgiaBoldItalic.ttf",
    },
    Helvetica: {
        normal: "HelveticaRegular.ttf",
        italics: "HelveticaItalic.ttf",
        bold: "HelveticaBold.ttf",
        bolditalics: "HelveticaBoldItalic.ttf",
    },
    LucidaSansUnicode: {
        normal: "LucidaSansRegular.TTF",
        italics: "LucidaSansItalic.TTF",
        bold: "LucidaSansBold.TTF",
        bolditalics: "LucidaSansBoldItalic.TTF",
    },
    OpenSans: {
        normal: "OpenSans-Regular.ttf",
        italics: "OpenSans-Italic.ttf",
        bold: "OpenSans-Bold.ttf",
        bolditalics: "OpenSans-BoldItalic.ttf",
    },
    Tahoma: {
        normal: "TahomaRegular.ttf",
        italics: "TahomaItalic.ttf",
        bold: "TahomaBold.ttf",
        bolditalics: "TahomaBoldItalic.ttf",
    },
    TimesNewRoman: {
        normal: "TimesNewRomanRegular.ttf",
        italics: "TimesNewRomanItalic.ttf",
        bold: "TimesNewRomanBold.ttf",
        bolditalics: "TimesNewRomanBoldItalic.ttf",
    },
    TrebuchetMs: {
        normal: "TrebuchetMS.ttf",
        italics: "TrebuchetMS-Italic.ttf",
        bold: "TrebuchetMS-Bold.ttf",
        bolditalics: "TrebuchetMS-BoldItalic.ttf",
    },
    Verdana: {
        normal: "VerdanaProRegular.ttf",
        italics: "VerdanaProItalic.ttf",
        bold: "VerdanaProSemiBold.ttf",
        bolditalics: "VerdanaProSemiBoldItalic.ttf",
    },
}
export default fontList